import type { DrawerRootProps } from '@base-ui/react';

import { Drawer as BaseDrawer } from '@base-ui/react';

type Props = DrawerRootProps;

export const DrawerRoot = ({ children, ...delegated }: Props) => {
  return (
    <BaseDrawer.Root {...delegated} swipeDirection={delegated.swipeDirection ?? 'right'}>
      {children}
    </BaseDrawer.Root>
  );
};
